import { Suspense } from 'react';
import { AdminPayoutsClient } from './admin-payouts-client';

export const metadata = { title: 'Payouts · Admin' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <AdminPayoutsClient />
    </Suspense>
  );
}
